import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";

import { storage, database } from "../firebase";

export default function AlertDialog(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deleteTemplate = () => {
    const storageRef = storage.ref(`templates/${props.template.metadata.name}`);

    storageRef
      .delete()
      .then(() => {
        const dbRef = database.ref(
          `templates/${props.template.metadata.generation}`
        );

        return dbRef.set(null);
      })
      .then(() => {
        props.setTemplates([]);
        setOpen(false);
      });
  };

  return (
    <div>
      <IconButton
        sx={{ color: "rgba(255, 255, 255, 0.54)" }}
        onClick={handleClickOpen}
      >
        <Delete />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Vuoi veramente eliminare il template ${props.template.metadata.name}?`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Una volta eliminato, non potrà più essere ripristinato
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Indietro
          </Button>
          <Button onClick={deleteTemplate} color="warning">
            Elimina
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
